import AppSwiper from "../../../components/common/AppSwiper/AppSwiper";
import ProductCard from "../../../components/ProductCard/ProductCardNew";

export default function RelatedProducts({
    products = [],
}) {
    if (!products.length) {
        return null;
    }

    return (
        <section className="article-related-section">

            <div className="article-related-section__header">

                <div>
                    <span className="article-related-section__eyebrow">
                        پیشنهاد ما
                    </span>

                    <h2>
                        محصولات مرتبط
                    </h2>
                </div>

            </div>

            <div className="related-products-slider">

                <AppSwiper
                    slidesPerView={5}
                    spaceBetween={16}
                    navigation={true}
                    pagination={false}
                    loop={false}
                    className="related-products-swiper"
                >

                    {products.map((product) => (
                        <ProductCard
                            key={product.id}
                            product={product}
                        />
                    ))}

                </AppSwiper>

            </div>

        </section>
    );
}